import { styled } from "styled-components";
import { AiOutlineUndo, AiOutlineArrowRight } from "react-icons/ai";

const FormActionButton = (props) => {
    return (
        <CustomButton bg={props.bg} onClick={props.onClick} type={props.type} >
            {props.children}
            {props.bg === '#ff6b6b' ? <AiOutlineUndo /> : <AiOutlineArrowRight />}
        </CustomButton>
    );
}

export default FormActionButton;

const CustomButton = styled.button`
    width: 12rem;
    height: 4rem;
    background-color: ${({bg}) => bg};
    border: none;
    color: #fff;
    font-size: 1.5rem;
    letter-spacing: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    border-radius: 0.2rem;
    cursor: pointer;
    &:hover {
        transform: translateY(-2px);
        box-shadow: 5px 5px 5px #ccc;
    }
    &:active {
        transform: translateY(0);
        box-shadow: 3px 3px 3px #ccc;
    }
`;
